import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    component: () => import("@/views/index.vue"),
    meta: {
      title: "随心淘",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_HaiLuo",
    component: () => import("@/views/monthlyHotTopicsNTo2_HaiLuo/index.vue"),
    meta: {
      title: "欢心享",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_HaiLuo/receive",
    component: () =>
      import("@/views/monthlyHotTopicsNTo2_HaiLuo/receive/index.vue"),
    meta: {
      title: "欢心享",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_HaiLuo/receive/login",
    component: () =>
      import("@/views/monthlyHotTopicsNTo2_HaiLuo/receive/login.vue"),
    meta: {
      title: "欢心享",
    },
  },
  {
    path: "*",
    component: () => import("@/views/404.vue"),
    meta: {
      title: "404",
    },
  },
  {
    path: "/tao/equityCenter/zfblogin/login",
    component: () => import("@/views/tao/equityCenter/login.vue"),
    meta: {
      title: "随心淘",
    },
  },
  {
    path: "/tao/equityCenter/homePage",
    component: () => import("@/views/tao/equityCenter/homePage.vue"),
    meta: {
      title: "随心淘",
    },
  },
  {
    path: "/tao/equityCenter/record",
    component: () => import("@/views/tao/equityCenter/record.vue"),
    meta: {
      title: "随心淘",
    },
  },

  {
    path: "/refund",
    component: () => import("@/views/refund/index.vue"),
    meta: {
      title: " ",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_HaiLuo/test",
    component: () => import("@/views/monthlyHotTopicsNTo2_HaiLuo/test.vue"),
    meta: {
      title: "欢心享",
    },
  },
  {
    path: "/suixinxiang25",
    component: () => import("@/views/suixinxiang25/index.vue"),
    meta: {
      title: "随心享",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_GuangTong",
    component: () => import("@/views/monthlyHotTopicsNTo2_GuangTong/index.vue"),
    meta: {
      title: "随心享",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_GuangTong/activityRule",
    component: () =>
      import("@/views/monthlyHotTopicsNTo2_GuangTong/activityRule.vue"),
    meta: {
      title: "随心会员",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_YunXian",
    component: () => import("@/views/monthlyHotTopicsNTo2_YunXian/index.vue"),
    meta: {
      title: "随心会员",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_YunXian/rule",
    component: () => import("@/views/monthlyHotTopicsNTo2_YunXian/rule.vue"),
    meta: {
      title: "随心会员",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_YunXian/receive",
    component: () =>
    import("@/views/monthlyHotTopicsNTo2_YunXian/receive/index.vue"),
    meta: {
      title: "欢心享",
    },
  },
  {
    path: "/monthlyHotTopicsNTo2_zhengxing",
    component: () => import("@/views/monthlyHotTopicsNTo2_zhengxing/index.vue"),
    meta: {
      title: "随心享",
    },
  },
  {
    path: "/suixinxiang25/selfInvestment",
    component: () => import("@/views/suixinxiang25/selfInvestment.vue"),
    meta: {
      title: "随心享",
    },
  },
  {
    path: "/suixinxiang25/xiaoyang",
    component: () => import("@/views/suixinxiang25/xiaoyang.vue"),
    meta: {
      title: "随心享",
    },
  },
  {
    path: "/monthlyHotVipNTo2_zhengxing/index.vue",
    component: () => import("@/views/monthlyHotVipNTo2_zhengxing/index.vue"),
    meta: {
      title: "月月热门会员N选2",
    },
  },
  {
    path: "/monthlyHotVipNTo2_zhengxing/userRule.vue",
    component: () => import("@/views/monthlyHotVipNTo2_zhengxing/userRule.vue"),
    meta: {
      title: "月月热门会员N选2",
    },
  },
  {
    path: "/monthlyHotVipNTo2_zhengxing/activity.vue",
    component: () => import("@/views/monthlyHotVipNTo2_zhengxing/activity.vue"),
    meta: {
      title: "月月热门会员N选2",
    },
  },
  {
    path: "/petroChina",
    component: () => import("@/views/petroChina/index.vue"),
    meta: {
      title: "中国石油加油权益包",
    },
  },
  {
    path: "/foodSuiXinXiang",
    component: () => import("@/views/foodSuiXinXiang/index.vue"),
    meta: {
      title: "美食随心享",
    },
  },
  {
    path: "/tao/memberBenefits/notOpened/notOpened",
    component: () => import("@/views/tao/memberBenefits/notOpened/notOpened.vue"),
    meta: {
      title: "随心淘会员",
    },
  },
  {
    path: "/tao/memberBenefits/notOpened/agreement/rules",
    component: () => import("@/views/tao/memberBenefits/notOpened/agreement/rules.vue"),
    meta: {
      title: "活动规则",
    },
  },
  {
    path: "/tao/memberBenefits/notOpened/agreement/agreement",
    component: () => import("@/views/tao/memberBenefits/notOpened/agreement/agreement.vue"),
    meta: {
      title: "会员服务协议",
    },
  },
  {
    path: "/tao/memberBenefits/notOpened/agreement/renew",
    component: () => import("@/views/tao/memberBenefits/notOpened/agreement/renew.vue"),
    meta: {
      title: "自动续费",
    },
  },
  {
    path: "/tao/memberBenefits/opened/opened",
    component: () => import("@/views/tao/memberBenefits/opened/opened.vue"),
    meta: {
      title: "随心淘会员",
    },
  },
  {
    path: "/tao/memberBenefits/record/collection/collection",
    component: () => import("@/views/tao/memberBenefits/record/collection/collection.vue"),
    meta: {
      title: "领取记录",
    },
  },
  {
    path: "/tao/memberBenefits/record/deduction/deduction",
    component: () => import("@/views/tao/memberBenefits/record/deduction/deduction.vue"),
    meta: {
      title: "扣费记录",
    },
  },
  {
    path: "/lifeQuotient_zhengxing",
    component: () => import("@/views/lifeQuotient_zhengxing/index.vue"),
    meta: {
      title: "生活商超会",
    },
  },
  {
    path: "/carOwner_zhengxing",
    component: () => import("@/views/carOwner_zhengxing/index.vue"),
    meta: {
      title: "车主出行惠",
    },
  },
  {
    path: "/carOwner_zhengxing/receive/login",
    component: () => import("@/views/carOwner_zhengxing/receive/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/carOwner_zhengxing/receive/homePage",
    component: () => import("@/views/carOwner_zhengxing/receive/homePage.vue"),
    meta: {
      title: "会员福利中心",
    },
  },
  {
    path: "/carOwner_zhengxing/receive/record",
    component: () => import("@/views/carOwner_zhengxing/receive/record.vue"),
    meta: {
      title: "领取记录",
    },
  },
  {
    path: "/carOwner_zhengxing/receive/membership",
    component: () => import("@/views/carOwner_zhengxing/receive/membership.vue"),
    meta: {
      title: "车主会员",
    },
  },
  {
    path: "/carOwner",
    component: () => import("@/views/carOwner/index.vue"),
    meta: {
      title: "车主权益",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
